import { useMemo } from "react";
import { useChosenDepartment } from "../../contexts/ChosenDepartment";
import { hasHrisIntegrationOfType } from "../../utils/hrisIntegrations";

export const usePayrollConfirmation = (showActual: boolean) => {
	const { chosenDepartment } = useChosenDepartment();
	const hasShiftsIntegration = hasHrisIntegrationOfType(chosenDepartment, "shifts");

	return useMemo<boolean>(() => showActual && hasShiftsIntegration, [showActual, hasShiftsIntegration]);
};
